import Styleguide from "@store/Framework/Types/Styleguide";

const header: Styleguide["header"] = {
    isCompactHeader: false,
    backgroundColor: "menu.mainNavigation",
    linkColor: null as any,
    isDropShadow: true,
    isFullWidth: true,
    fullWidthStylingType: null as any,
    fullWidthColor: null as any,
    fullWidthImage: null as any,
    fullWidthImageFocalPoint: null as any,
};

export default header;
